import axios from "axios";
import React, { useEffect, useState } from "react";
import { DataAPi, Valuasi, EndPoint} from "./variable/dataVariable";
import TableVA from "./table/tableVA";
import { Temporal } from '@js-temporal/polyfill';
import VaService from "../services/virtualAkun.service";

function VirtualAkun() {
    const nowTime = Temporal.Now.zonedDateTimeISO().toString({ timeZoneName: 'never' });
    const [data, setData] = useState([]);
    
    /*const body = {
        "partnerServiceId": "90168",
        "startDate": "2020-12-31",
        "startTime": "14:56:11+07:00",
        "endDate": "2021-12-31",
        "endTime": "14:56:11+07:00",
        "additionalInfo": {}
    }*/

    const body = {
  "partnerServiceId": "  088899",
  "customerNo": "12345678901234567890",
  "virtualAccountNo": "  08889912345678901234567890",
  "inquiryRequestId": "abcdef-123456-abcdef",
  "paymentRequestId": "abcdef-123456-abcdef",
  "partnerReferenceNo": "abcdef-123456-abcdef",
  "trxDateTime": "2020-12-21T14:56:11+07:00",
  "paymentStatus": "Success",
  "paymentFlagReason": {
    "english": "Success",
    "indonesia": "Sukses"
  },
  "additionalInfo": {}
}

    /*const data = [
        {
            "paymentFlagReason": {
                "english": "Success",
                "indonesia": "Sukses"
            },

            "partnerServiceId": "  088899",
            "customerNo": "1234567890123456789",
            "virtualAccountNo": "0008889912345678901234567890",
            "virtualAccountName": "Jokul Doe",
            "virtualAccountEmail": "john@email.com",
            "virtualAccountPhone": "6281828384858",
            "sourceAccountNo": "1234567890",
            "sourceAccountType": "s",
            "trxId": "abcdefgh1234",
            "inquiryRequestId": "abcdef-123456-abcdef",
            "paymentRequestId": "abcdef-123456-abcdef",

            "paidAmount": {
                "value": "55000",
                "currency": "IDR"
            },

            "paidBills": "100101",

            "totalAmount": {
                "value": "88000",
                "currency": "IDR"
            },

            "trxDateTime": "20201231T235959Z",
            "referenceNo": "123456789012345",
            "journalNum": "123456",
            "paymentType": "1",
            "flagAdvise": "Y",

            "billDetails": [
            {
                "billCode": "00",
                "billNo": "123456789012345678",
                "billName": "SPP",
                "billShortName": "Bill A",
                "billDescription": {
                    "english": "Maintenance",
                    "indonesia": "Pembayaran SPP Ganjil 2025"
                },
                "billSubCompany": "00001",
                "billAmount": {
                    "value": "50000",
                    "currency": "IDR"
                },
                "additionalInfo": {},
                "status": "00",
                "reason": {
                    "english": "Success",
                    "indonesia": "Sukses"
                }
            }],

            "freeTexts": [
            {
                "english": "Free text",
                "indonesia": "Tulisan bebas"
            }],
            "additionalInfo": {
                "nama": "Jokul Doe",
                "nim": "12345",
                "prodi": "Hukum",
                "fakultas": "Hukum"
            }
        }]*/
    
    useEffect(() => {

        const getAset = async() => {
            await VaService.signatureAuth(nowTime)
            .then(res => {
                console.log(res)
                VaService.accessToken(nowTime, res.signature)
                .then(res => {
                    console.log(res)
                    VaService.signatureService(res.accessToken, nowTime, EndPoint.notifBank, body, "POST")
                    .then(res => {
                        console.log(res)
                        VaService.servicesVA(nowTime, EndPoint.notifBank, res.signature, body)
                        .then(res => {
                            console.log(res);
                            
                            setData(res.data)
                        })
                    })
                    .catch(err => console.log(err))
                })
                .catch(err => console.log(err))
            })
            .catch(err => console.log(err));
        }
        getAset();
    },[]);

    return(
        <>
        <div className="container justify-content-center bg-light">
            <br />
            <TableVA dataSet={data} />
            <br />
        </div>
        </>
    )
}

export default VirtualAkun;